if(!customElements.get('sizechart-tab')) {
    class SizechartTab extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.buttons = [...this.querySelectorAll('[tab-button]')];
            if (!(this.buttons.length > 1)) return;
            
            this.buttons.forEach((button) => {
                button.addEventListener('click', this.handleTabClick.bind(this));
            });
        }
        handleTabClick(e) {
            const clickedButton = e.currentTarget;
            const tabId = clickedButton.id;
            if (clickedButton.classList.contains('is-active')) return;

            const currentButton = this.querySelector('.size-guide-tab-button.is-active');
            currentButton?.classList.remove('is-active');
            clickedButton.classList.add('is-active');

            const currentTab = this.querySelector('.tab-content:not(.hidden)');
            currentTab?.classList.add('hidden');

            const newTab = this.querySelector(`#tab-content-${tabId}`);
            newTab?.classList.remove('hidden');

        }
    }
    customElements.define('sizechart-tab', SizechartTab);
}